import OrderBumpSelector from '@/components/config-editor/form-elements/OrderBumpSelector';
import { WidgetProps } from '@rjsf/utils';

function OrderBumpSelectorWidget(props: WidgetProps) {
  return <OrderBumpSelector value={props.value} onChange={props.onChange} />;
}

export default OrderBumpSelectorWidget;
